import { Component, ElementRef, HostListener, Input, inject } from '@angular/core';

@Component({
  selector: 'glxy-chat-event',
  templateUrl: './chat-event.component.html',
  styleUrls: ['./chat-event.component.scss'],
  standalone: false,
})
export class ChatEventComponent {
  @Input() messageMetadata?: string | null;

  isMetadataPresented = false;

  private eRef = inject(ElementRef);
  private clickTimeout = 0;

  @HostListener('document:mousedown', ['$event'])
  onMouseDown(event: MouseEvent) {
    // Check if there is any selected text
    const selectedText = window.getSelection()?.toString();
    if (selectedText) {
      return;
    }

    // Clear any existing click timeout
    window.clearTimeout(this.clickTimeout);

    // Start a new click timeout with a delay of 300 milliseconds
    this.clickTimeout = window.setTimeout(() => {
      // Check if the target is outside of the .bubble element
      if (!this.eRef.nativeElement.querySelector('.pill')?.contains(event.target)) {
        this.isMetadataPresented = false;
      }
    }, 300);
  }

  @HostListener('document:click', ['$event'])
  onClick(event: MouseEvent) {
    // Check if there is any selected text
    const selectedText = window.getSelection()?.toString();
    if (selectedText) {
      return;
    }

    // Clear any existing click timeout
    window.clearTimeout(this.clickTimeout);

    // Check if the target is inside the .pill element and not a link
    const isLink = event.target instanceof HTMLAnchorElement;
    if (!isLink && this.eRef.nativeElement.querySelector('.pill')?.contains(event.target)) {
      this.isMetadataPresented = !this.isMetadataPresented;
    } else {
      this.isMetadataPresented = false;
    }
  }
}
